import { TABLET_BREAKPOINT } from './use-row-virtualizer';
import { useMediaQuery } from './use-media-query';

/**
 * The responsive rule every side/bottom drawer in this app shares (first
 * `favorites-drawer`, now `downloads-drawer` too): a floating side panel
 * from tablet width up, a bottom sheet below it. Centralized so the widgets
 * can't drift -- pass the result straight to the shadcn `Drawer`'s own
 * `swipeDirection` prop.
 *
 * `side` picks which edge the large-screen panel hangs off -- `'right'` by
 * default; the issue reader's table of contents passes its reading
 * direction's start edge (`'left'` for LTR, `'right'` for RTL), so it opens
 * from the same side as its bottom-left cover trigger. Small screens are a
 * bottom sheet regardless.
 */
export function useDrawerSwipeDirection(
	side: DrawerSide = 'right',
): DrawerSide | 'down' {
	const isLargeScreen = useMediaQuery(`(min-width: ${TABLET_BREAKPOINT}px)`);
	return isLargeScreen ? side : 'down';
}

export type DrawerSide = 'left' | 'right';
